// Hidden for now. The routes still answer by URL; delete a line to bring an entry back.

/** Menu entries by path (Seth, 2026-11-04: "hide msd products and poynt collect for now"). */
export const HIDDEN_NAV: ReadonlySet<string> = new Set(["/products", "/poynt-collect"]);

/** Products left out of the lockup switcher, as the Dashboard hides them (Gifts: Dashboard dev #193, #214). */
export const HIDDEN_PRODUCTS: ReadonlySet<string> = new Set(["gifts"]);
